import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Rx';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class HttpService {

	private BASE_URL:string = 'http://localhost:8080/api/users/';

	constructor(
		private http:Http
	) { }

	public getdata(page:Number):any{
		return this.http.get(`http://localhost/slim5/public/employee/2/3`)
			.map((response:Response) => response.json());
		//	.catch((error:any) => Observable.throw(error.json().error) || 'Server Error');
	}

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/http.service.ts